import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';

import { getFoldersQueryKey } from './getFolders';
import { getTrashQueryKey } from './getTrash';

const url = `${PREFIX_URL}/library/delete`;

type PermanentDeleteResponse = { status: boolean };
type PermanentDeleteDTO = {
  folderIds: number[];
};

export const permanentDelete = ({
  folderIds,
}: PermanentDeleteDTO): Promise<PermanentDeleteResponse> => {
  return axios.post(url, { ids: folderIds });
};

type UsePermanentDeleteOptions = {
  config?: MutationConfig<typeof permanentDelete>;
};

export const usePermanentDelete = ({ config }: UsePermanentDeleteOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getFoldersQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getTrashQueryKey.list });
    },
    mutationFn: (props) => permanentDelete(props),
  });
};
